import { render, staticRenderFns } from "./UnitArrival.vue?vue&type=template&id=0d799e68&scoped=true"
import script from "./UnitArrival.vue?vue&type=script&lang=js"
export * from "./UnitArrival.vue?vue&type=script&lang=js"
import style0 from "./UnitArrival.vue?vue&type=style&index=0&id=0d799e68&prod&lang=scss"
import style1 from "./UnitArrival.vue?vue&type=style&index=1&id=0d799e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d799e68",
  null
  
)

export default component.exports